<template>
  <form @submit.prevent="handleSubmit(item)">
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.email) }">
      <label for="_email" class="control-label">Email</label>
      <input v-model="item.email" type="text"  placeholder=""  id="_email" class="form-control" />
      <span v-if="errors && errors.email" class="help-block" id="_email_helpBlock">{{ errors.email }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.fullname) }">
      <label for="_fullname" class="control-label">Full Name</label>
      <input v-model="item.fullname" type="text"  placeholder=""  id="_fullname" class="form-control" />
      <span v-if="errors && errors.fullname" class="help-block" id="_fullname_helpBlock">{{ errors.fullname }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.plainPassword) }">
      <label for="_plainPassword" class="control-label">Plain Password</label>
      <input v-model="item.plainPassword" type="text"  placeholder=""  id="_plainPassword" class="form-control" />
      <span v-if="errors && errors.plainPassword" class="help-block" id="_plainPassword_helpBlock">{{ errors.plainPassword }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.username) }">
      <label for="_username" class="control-label">Username</label>
      <input v-model="item.username" type="text"  placeholder=""  id="_username" class="form-control" />
      <span v-if="errors && errors.username" class="help-block" id="_username_helpBlock">{{ errors.username }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.enabled) }">
      <label for="_enabled" class="control-label">Enabled</label>
      <input v-model="item.enabled" type="checkbox"  placeholder=""  id="_enabled" class="form-control" />
      <span v-if="errors && errors.enabled" class="help-block" id="_enabled_helpBlock">{{ errors.enabled }}</span>
    </div>
    <div :class="{ 'form-group': true, 'has-error': (errors && errors.roles) }">
      <label for="_roles" class="control-label">Roles</label>
      <select v-model="item.roles" multiple id="_roles" class="form-control" >
        <option v-for="(value) in roles" v-bind:value="value">{{ value }}</option>
      </select>
      <span v-if="errors && errors.roles" class="help-block" id="_roles_helpBlock">{{ errors.roles }}</span>
    </div>

    <button type="submit" class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
  export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values;
      }
    },
      data: function () {
          return {
              roles:['ROLE_ADMIN','ROLE_USER']
          }
      }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Form.vue